export const makeFakeEmail = (username) => {
  return `${username.trim().toLowerCase()}@heydiari.com`;
};